import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const LoadingShimmer = ({
  columns = 8,
  rows = 10,
  avatarColumnIndex = null,
  actionColumnIndex = null,
  header = true,

}) => {
  return (
    <div className="card basic-data-table text-sm">
      {header && (
        <div className="card-header d-flex align-items-center justify-content-end">
          <Skeleton width={120} height={35} />
        </div>
      )}

      <div className="card-body">
        <div className="w-full overflow-x-auto">
          <table className="table bordered-table mb-0 text-sm w-full min-w-max">
            <thead>
              <tr>
                {[...Array(columns)].map((_, i) => (
                  <th key={i} className="py-2 px-3">
                    <Skeleton height={20} />
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {[...Array(rows)].map((_, row) => (
                <tr key={row} className="align-middle">
                  {[...Array(columns)].map((_, col) => {
                    // Avatar column
                    if (col === avatarColumnIndex) {
                      return (
                        <td key={col} className="py-2 px-3 text-center">
                          <Skeleton circle width={40} height={40} />
                        </td>
                      );
                    }

                    // Action column
                    if (col === actionColumnIndex) {
                      return (
                        <td
                          key={col}
                          className="py-2 px-3"
                          style={{ whiteSpace: "nowrap", textAlign: "center" }}
                        >
                          <Skeleton
                            width={32}
                            height={32}
                            circle
                            style={{ display: "inline-block", marginRight: 8 }}
                          />
                          <Skeleton
                            width={32}
                            height={32}
                            circle
                            style={{ display: "inline-block" }}
                          />
                        </td>
                      );
                    }

                    // Other columns
                    let width = "100%";
                    if (col === 1) width = 100; // Created Date
                    if (col === 3) width = 120; // Full Name
                    if (col === 4) width = 160; // Email
                    if (col === 5) width = 90;  // Role Name
                    if (col === 6) width = 80;  // Status

                    return (
                      <td key={col} className="py-2 px-3">
                        <Skeleton width={width} height={20} />
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-3 d-flex justify-content-end">
          <Skeleton width={150} height={30} />
        </div>
      </div>
    </div>
  );
};

export default LoadingShimmer;
